import { useMemo } from "react";

import Grid from "@mui/material/Grid";

import { LoadingOrValue } from "@covertree/ui";
import DisplayPropertiesCard from "@covertree/ui/content/DisplayPropertiesCard";
import { mapAddressToAddressLines } from "@utils/mapAddressToAddressLines";

import { PolicyDetailsContentProps } from "../../../types";

export function MailingAddress({ policy, loading }: PolicyDetailsContentProps) {
  const [propertyAddressLine1, propertyAddressLine2] = useMemo(
    () => mapAddressToAddressLines(policy?.policyholder?.mailingAddress),
    [policy?.units[0]?.address]
  );

  return (
    <>
      <Grid item xs={12}>
        <DisplayPropertiesCard
          properties={[
            {
              label: "Mailing address",
              value: (
                <LoadingOrValue
                  loading={!policy && loading}
                  value={propertyAddressLine1}
                  height={24}
                  width={121}
                />
              ),
              valueLine2: propertyAddressLine2,
              gridSize: 12,
              showAsTypography: true,
            },
          ]}
        />
      </Grid>
    </>
  );
}
